import React from "react";

const SMMBasicIcon = ({ color = "#5D5D5D" }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7048 8.72218V2.88012C15.7048 1.84177 14.8631 1 13.8247 1H4.95628C3.91792 1 3.07617 1.84177 3.07617 2.88012V24.7749"
        stroke="#1E1E1E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 24.7773H10.1984"
        stroke="#1E1E1E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.07617 5.82812H7.6305"
        stroke="#1E1E1E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.07617 10.5703H10.1992"
        stroke="#1E1E1E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4416 18.5004C21.2312 18.5004 22.6819 17.0496 22.6819 15.2599C22.6819 13.4703 21.2312 12.0195 19.4416 12.0195C17.6519 12.0195 16.2012 13.4703 16.2012 15.2599C16.2012 17.0496 17.6519 18.5004 19.4416 18.5004Z"
        stroke="#1E1E1E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8867 24.7782C13.8965 23.8307 14.1448 22.9012 14.6082 22.0764C15.5849 20.3385 17.4606 19.2349 19.4438 19.2305C21.4268 19.2349 23.3025 20.3385 24.2793 22.0764C24.7426 22.9012 24.9909 23.8307 25.0007 24.7782"
        stroke="#1E1E1E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SMMBasicIcon;
